var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.77273V16.75C10.5 18.8595 8.71 20.5682 6.5 20.5682C4.29 20.5682 2.5 18.8595 2.5 16.75V4.81818C2.5 4.18528 2.76339 3.5783 3.23223 3.13077C3.70107 2.68324 4.33696 2.43182 5 2.43182C5.66304 2.43182 6.29893 2.68324 6.76777 3.13077C7.23661 3.5783 7.5 4.18528 7.5 4.81818V14.8409C7.5 15.3659 7.05 15.7955 6.5 15.7955C5.95 15.7955 5.5 15.3659 5.5 14.8409V5.77273H4V14.8409C4 15.4738 4.26339 16.0808 4.73223 16.5283C5.20107 16.9759 5.83696 17.2273 6.5 17.2273C7.16304 17.2273 7.79893 16.9759 8.26777 16.5283C8.73661 16.0808 9 15.4738 9 14.8409V4.81818C9 2.70864 7.21 1 5 1C2.79 1 1 2.70864 1 4.81818V16.75C1 19.6518 3.46 22 6.5 22C9.54 22 12 19.6518 12 16.75V5.77273H10.5Z",
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdNotes);
export default __webpack_public_path__ + "static/media/CD Notes.19ea4316b9dd2fc9d9196bb29e071497.svg";
export { ForwardRef as ReactComponent };